"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationInput = void 0;
var react_1 = __importStar(require("react"));
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var utils_1 = require("./utils");
var ConfirmationInput = function (_a) {
    var _b, _c;
    var _d = _a.placeholderSymbol, placeholderSymbol = _d === void 0 ? "-" : _d, _e = _a.length, length = _e === void 0 ? 5 : _e, _f = _a.format, format = _f === void 0 ? "alpha-numeric" : _f, _g = _a.isValid, isValid = _g === void 0 ? true : _g, onChange = _a.onChange, htmlName = _a.htmlName, id = _a.id, value = _a.value, defaultValue = _a.defaultValue, providedOnFocus = _a.onFocus, providedOnBlur = _a.onBlur, rest = __rest(_a, ["placeholderSymbol", "length", "format", "isValid", "onChange", "htmlName", "id", "value", "defaultValue", "onFocus", "onBlur"]);
    /**
     * Spawn array of inputs with size of provided length(5 by default)
     *
     * Each input contain ref(reference to html input), active, which mark is input are selected(focused)
     * and value(which is modify html input value on write, and returns stored value from _value on read)
     */
    var inputs = react_1.useMemo(function () { return Array.from({ length: length }, function (_, i) {
        var _a, _b, _c;
        var inputObj = {
            ref: null,
            _value: (_c = (_b = ((_a = value === null || value === void 0 ? void 0 : value[i]) !== null && _a !== void 0 ? _a : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[i])) === null || _b === void 0 ? void 0 : _b.toUpperCase()) !== null && _c !== void 0 ? _c : "",
            active: false,
        };
        Object.defineProperty(inputObj, "value", {
            set: function (val) {
                this._value = val;
                if (this.ref)
                    this.ref.value = val;
            },
            get: function () {
                return this._value;
            }
        });
        return inputObj;
    }); }, [defaultValue, length, value]);
    var hiddenInput = react_1.useRef(null);
    var _h = react_1.useState((_c = (_b = (value !== null && value !== void 0 ? value : defaultValue)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) !== null && _c !== void 0 ? _c : ""), collectedValue = _h[0], setCollectedValue = _h[1];
    var _j = react_1.useState(false), isFocused = _j[0], setFocused = _j[1];
    var getInput = react_1.useCallback(utils_1.getInputOrEmpty(inputs), [inputs]);
    var focusOn = react_1.useCallback(function (index) {
        var _a;
        getInput(index).active = true;
        return (_a = getInput(index).ref) === null || _a === void 0 ? void 0 : _a.focus();
    }, [getInput]);
    var isAllowedSymbol = react_1.useCallback(utils_1.isAllowedSymbol(format), [format]);
    var performAfterChange = react_1.useCallback(function (newValue) {
        if (onChange)
            onChange(newValue);
        setCollectedValue(newValue);
    }, [onChange]);
    var onKeyDown = react_1.useCallback(function (event) {
        var key = event.key;
        var currentInputIndex = utils_1.getInputIndex(event.target);
        var nextInputIndex = currentInputIndex + 1;
        var prevInputIndex = currentInputIndex - 1;
        var currentInput = inputs[currentInputIndex];
        switch (key) {
            case utils_1.Keys.BACKSPACE:
            case utils_1.Keys.DELETE:
            case utils_1.Keys.ARROW_RIGHT:
            case utils_1.Keys.ARROW_LEFT:
                event.preventDefault();
                event.stopPropagation();
                break;
            default:
                // If key is unlisted special key or alt|ctrl|cmd pressed - skip keydown processing
                if (key.length > 1 || event.altKey || event.ctrlKey || event.metaKey)
                    return;
        }
        if (key === utils_1.Keys.ARROW_LEFT) {
            focusOn(prevInputIndex);
            return;
        }
        else if (key === utils_1.Keys.ARROW_RIGHT) {
            focusOn(nextInputIndex);
            return;
        }
        if (key === utils_1.Keys.BACKSPACE) {
            if (currentInput.value === "" && currentInputIndex === 0) {
                return; // Nothing to do if all inputs are empty
            }
            // If current input is empty - clear left side input
            var deleteIndex = currentInput.value === "" ? prevInputIndex : currentInputIndex;
            utils_1.shiftLeft(inputs, deleteIndex);
            focusOn(deleteIndex - 1);
        }
        else if (key === utils_1.Keys.DELETE) {
            if (inputs[nextInputIndex].value === "") {
                return; // Nothing to do if next input are empty
            }
            utils_1.shiftLeft(inputs, nextInputIndex);
        }
        performAfterChange(utils_1.getString(inputs));
    }, [inputs, performAfterChange, focusOn]);
    var onFocus = react_1.useCallback(function (event) {
        var _a, _b;
        var inputIndex = utils_1.getInputIndex(event.target);
        if (((_a = inputs[inputIndex - 1]) === null || _a === void 0 ? void 0 : _a.value) === "") {
            event.preventDefault();
            event.stopPropagation();
            var focusIndex = inputIndex;
            while (((_b = inputs[focusIndex - 1]) === null || _b === void 0 ? void 0 : _b.value) === "") {
                focusIndex--;
            }
            focusOn(focusIndex);
        }
    }, [focusOn, inputs]);
    var onPaste = react_1.useCallback(function (event) {
        var _a;
        if (event.type === "paste") {
            event.preventDefault();
            // @ts-ignore window.clipboardData exists on IE
            var data = (_a = (event.clipboardData || window.clipboardData)) === null || _a === void 0 ? void 0 : _a.getData("text");
            if (data) {
                var inputIndex_1 = utils_1.getInputIndex(event.target);
                data.split("").every(function (char, i) {
                    if (!isAllowedSymbol(char)) {
                        return false;
                    }
                    var input = inputs[inputIndex_1 + i];
                    if (input) {
                        input.value = char.toUpperCase();
                        focusOn(inputIndex_1 + i);
                        return true;
                    }
                    return false;
                });
                performAfterChange(utils_1.getString(inputs));
            }
        }
    }, [focusOn, inputs, isAllowedSymbol, performAfterChange]);
    var onMouseDown = react_1.useCallback(function (event) {
        event.preventDefault();
        focusOn(utils_1.getInputIndex(event.target));
    }, [focusOn]);
    var onBlur = react_1.useCallback(function (event) {
        getInput(utils_1.getInputIndex(event.target)).active = false;
    }, [getInput]);
    /**
     * Focus event handler for the wrapper, to imitate an input focus.
     * Since we have multiple inner inputs, we stop event propagation there and handle the focus for the wrapper
     */
    var onWrapperFocus = react_1.useCallback(function (event) {
        if (!isFocused) {
            if (providedOnFocus) {
                providedOnFocus(event);
            }
            setFocused(true);
        }
    }, [isFocused, providedOnFocus]);
    /**
     * Blur event handler for the wrapper, to imitate an input blur.
     * Similar idea as with onWrapperFocus
     */
    var onWrapperBlur = react_1.useCallback(function (event) {
        if (isFocused && inputs.every(function (input) { return !input.active; })) {
            if (providedOnBlur) {
                providedOnBlur(event);
            }
            setFocused(false);
        }
    }, [isFocused, providedOnBlur, inputs]);
    /**
     * Handles change event in each visible input.
     * If {@link event.target.value} is not empty, it is processed as adding a new character to the selected input.
     * Otherwise it is considered as an character deletion and the character will be deleted from current input.
     *
     * @param {ChangeEvent<HTMLInputElement>} event - Input's change event
     *
     */
    var onCodeInputChange = react_1.useCallback(function (event) {
        var _a;
        var currentInputIndex = utils_1.getInputIndex(event.target);
        var nextInputIndex = currentInputIndex + 1;
        var enteredValue = event.target.value.slice(-1);
        var currentInput = inputs[currentInputIndex];
        if (enteredValue) {
            var isAllInputsFilled = inputs[length - 1].value !== "";
            if (isAllInputsFilled || !isAllowedSymbol(enteredValue)) {
                return;
            }
            var editIndex = currentInput.value === "" ? currentInputIndex : nextInputIndex;
            utils_1.shiftRight(inputs, editIndex);
            inputs[editIndex].value = enteredValue.toUpperCase();
            focusOn(((_a = inputs[nextInputIndex]) === null || _a === void 0 ? void 0 : _a.value) === "" ? nextInputIndex : editIndex);
        }
        else {
            if (currentInput.value === "" && currentInputIndex === 0) {
                return; // Nothing to do if all inputs are empty
            }
            // If current input is empty - clear left side input
            var deleteIndex = currentInput.value === "" ? currentInputIndex - 1 : currentInputIndex;
            utils_1.shiftLeft(inputs, deleteIndex);
            focusOn(deleteIndex - 1);
        }
        performAfterChange(utils_1.getString(inputs));
    }, [focusOn, inputs, isAllowedSymbol, length, performAfterChange]);
    return (react_1.default.createElement(theme_ui_1.Flex, { sx: {
            position: "relative",
            minHeight: theme_1.theme.sizes[6],
            border: "2px solid " + (isValid ? theme_1.theme.colors.grey900 : theme_1.theme.colors.warningRed),
            width: "fit-content",
            // We need exactly 10px according to provided design
            padding: "0 10px",
            ":focus-within": {
                borderColor: isValid ? theme_1.theme.colors.primaryLight : theme_1.theme.colors.warningRed
            },
            backgroundColor: theme_1.theme.colors.backgroundBlue,
            transition: "0.2s ease-out",
        }, onFocus: onWrapperFocus, onBlur: onWrapperBlur, id: id },
        react_1.default.createElement("input", __assign({ type: "hidden", name: htmlName, value: collectedValue, ref: hiddenInput, onChange: utils_1.noop }, rest)),
        inputs.map(function (input, i) { return (react_1.default.createElement(theme_ui_1.Input, { ref: function (el) {
                input.ref = el;
            }, value: input.value, onChange: onCodeInputChange, onKeyDown: onKeyDown, onFocus: onFocus, onPaste: onPaste, onMouseDown: onMouseDown, onBlur: onBlur, placeholder: placeholderSymbol, "data-index": i, autoFocus: true, key: i, sx: {
                border: "none",
                outline: "none",
                // We need exactly 10px according to provided design
                padding: "10px",
                textAlign: "center",
                width: "40px",
                fontFamily: "inherit"
            } })); })));
};
exports.ConfirmationInput = ConfirmationInput;
